const BOARD_COLORS = [
  ['#337b84', '#235364'],
  ['#80519b', '#564276'],
  ['#a65f35', '#7d422b'],
  ['#3d6caa', '#334d7e'],
  ['#996079', '#713d58'],
  ['#407858', '#2f5544'],
  ['#6861a4', '#47436f'],
  ['#7c7052', '#59513d'],
];

export const getBoardAvatarSrc = (board = {}) => {
  const name = String(board.name || '');
  const words = name.match(/[\p{L}\p{N}]+/gu) || [];
  const initials = Array.from(words.slice(0, 2)
    .map(word => Array.from(word)[0]).join('').toUpperCase()).slice(0, 2).join('') || '?';
  // Use the board identity so a rename never changes its assigned palette.
  const seed = String(board._id || board.id || name);
  let hash = 0;
  for (const character of seed) {
    hash = (Math.imul(31, hash) + character.codePointAt(0)) | 0;
  }
  const [start, end] = BOARD_COLORS[(hash >>> 0) % BOARD_COLORS.length];
  // Initials contain only Unicode letters/numbers (or the fixed fallback).
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
    <defs><linearGradient id="boardGradient" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="${start}"/><stop offset="1" stop-color="${end}"/>
    </linearGradient></defs>
    <rect width="96" height="96" rx="24" fill="url(#boardGradient)"/>
    <text x="48" y="50" text-anchor="middle" dominant-baseline="middle"
      fill="#fff" font-family="Arial, Helvetica, sans-serif" font-weight="500"
      font-size="${Array.from(initials).length === 1 ? 42 : 34}">${initials}</text>
  </svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
